module.exports = __webpack_public_path__ + "img/img_makeup_mobile.bb21c51.png";